import React, { useState } from 'react';
import { Table, Row, Col, Button } from 'antd';
import { useParams } from 'react-router-dom';
import { createFirstProject } from 'services/home.js';
import { useNavigate } from 'react-router-dom';
import icon_processing from 'images/icon_processing.svg';

const FinalPreview = (props) => {
    const { id } = useParams();
    let navigate = useNavigate();

    const [IsSpinner, setIsSpinner] = useState(false);
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    background: '#f1f3f4'
                }}
            >
                <div
                    className="final-view-table"
                    style={{
                        width: '52%',
                        overflow: 'scroll',
                        border: '3px solid #60091D',
                        height: 'calc(100vh - 112px)'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            position: 'sticky',
                            width: '100%',
                            top: '0',
                            zIndex: '1000',
                            justifyContent: 'center',
                            left: '0',
                            backgroundColor: '#fafafa'
                        }}
                    >
                        <div className="header-preview">
                            ECONOMETRICA PREVIEW
                        </div>
                    </div>
                    <Table
                        columns={props.columnsFinalPreview}
                        dataSource={props.dataFinalPreview}
                        pagination={false}
                        scroll={true}
                    />
                </div>
                <div
                    className="eco-fonal-preview"
                    style={{
                        width: '47%',
                        height: 'calc(100vh - 158px)',
                        overflow: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between'
                    }}
                >
                    <div>
                        <div className="title">Econometrica Preview</div>
                        <div className="description">
                            This is how your data will appear in Econometrica.
                            If this is how you want your data to be presented
                            click “<span>Upload</span>”. If not, click “
                            <span>Back</span>” and make the necessary changes.
                        </div>
                    </div>
                    <div>
                        <Col
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                marginTop: '21px',
                                marginBottom: '21px'
                                // marginRight: 31
                            }}
                            span={24}
                        >
                            <Button
                                onClick={() => {
                                    setIsSpinner(true);
                                    createFirstProject(id).then((res) => {
                                        navigate(
                                            `/project/${res.data.project_full_id}?uploaded=1`
                                        );
                                    });
                                }}
                                className="blue-button"
                                style={{ width: 250 }}
                                type="primary"
                                block
                            >
                                {IsSpinner ? (
                                    <img
                                        className="processing-spin"
                                        src={icon_processing}
                                    />
                                ) : (
                                    'UPLOAD'
                                )}
                                {/* UPLOAD */}
                            </Button>
                            <Button
                                onClick={() => {
                                    props.setFinalPreviewVisible(false);
                                    props.setHeaderValue(0);
                                    props.setHeaderInputValue(0);
                                    props.setRowValue(0);
                                }}
                                style={{
                                    width: 250,
                                    marginTop: 15,
                                    borderColor: '#578cba',
                                    color: '#578cba'
                                }}
                                block
                            >
                                BACK
                            </Button>
                        </Col>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FinalPreview;
